import React from 'react'
import { UnderwritingOffer } from '_gql'

import { FormattedMessage, useIntl } from '@divvy-web/i18n'

import CreditLineOfferPage from '@sputnik/pages/PostApplicationPages/CreditLineOffersPage/CreditLineOfferPage'
import { URL } from '@sputnik/resources/constants'

const StandardCreditLineOfferPage = () => {
  const { formatMessage } = useIntl()

  return (
    <CreditLineOfferPage
      bulletPoints={[
        <FormattedMessage
          key='fixed-credit-limit'
          defaultMessage='Your credit limit is fixed and typically won’t change.'
          id='sputnik.StandardCreditLineOffer__kT0CVZ'
        />,
        <FormattedMessage
          key='request-credit-limit-increase'
          defaultMessage='You can request credit limit increases right from your dashboard.'
          id='sputnik.StandardCreditLineOffer__BwrSOE'
        />,
        <FormattedMessage
          key='balance-due'
          defaultMessage='Your balance is due in full at the end of each billing cycle.'
          id='sputnik.StandardCreditLineOffer__8LBAFn'
        />,
      ]}
      learnMoreLink={URL.STANDARD_LINE_OFFER_LEARN_MORE_LINK}
      marketingImage={{
        src: 'https://app.divvy.co/assets/stock-photos/credit-application-standard-line-offer-content.png',
        alt: formatMessage({
          defaultMessage: 'photographer taking an picture of a mountain range',
          id: 'sputnik.VariableCreditLineOfferPage__bbLO24',
        }),
      }}
      title={
        <FormattedMessage
          defaultMessage='Standard credit line offer'
          id='sputnik.StandardCreditLineOffer__qp7R73'
        />
      }
      underwritingOfferType={UnderwritingOffer.FIXED_LINE}
    />
  )
}

export default StandardCreditLineOfferPage
